export function padNumberToString(value: number, padding: string): string {
  return (padding + value.toString()).substring(value.toString().length)
}

export function toDisplayText(text: string): string {
  return text.trim().replace('_', ' ').toLowerCase()
}
